/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type ProfileNotificationsPage_viewer = {
    readonly projectOwner: boolean | null;
    readonly disableNotifications: boolean | null;
    readonly company: {
        readonly forecastDemo: boolean | null;
        readonly tier: TierType | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"profileNotificationsSettings_viewer" | "ProfileProjectStatusUpdates_viewer" | "SettingsProfileSubNav_viewer">;
    readonly " $refType": "ProfileNotificationsPage_viewer";
};
export type ProfileNotificationsPage_viewer$data = ProfileNotificationsPage_viewer;
export type ProfileNotificationsPage_viewer$key = {
    readonly " $data"?: ProfileNotificationsPage_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProfileNotificationsPage_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileNotificationsPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastDemo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "profileNotificationsSettings_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileProjectStatusUpdates_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '75c2ba418602156e5cf047e975b1e0b8';
export default node;
